import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import {NavLink, Link} from 'react-router-dom';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import DatePicker from "react-datepicker";
import NoticeItem from './NoticeItem';



class General extends Component {
    constructor(props)
    {
        super(props);

        this.fetchGeneral = this.fetchGeneral.bind(this);
        this.renderAnnouncements = this.renderAnnouncements.bind(this);

        this.deletePost = this.deletePost.bind(this);
        this.switchMode = this.switchMode.bind(this);
        this.editPost = this.editPost.bind(this);

        this.updateTitle = this.updateTitle.bind(this);
        this.updateContent = this.updateContent.bind(this);
        this.updateDepartment = this.updateDepartment.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);

        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            announcements:[],
            term: "",
            server_response:"",
            api_error:true,
            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false,

        
            selectedPost:{}

        }
    }

    updateStartDate(date)
    {
      this.state.selectedPost.startDate = date; 
    }

    updateEndDate(date)
    {
      this.setState({endDate:date}); 
      this.state.selectedPost.endDate = date; 
    }



   updateTitle(event)
    {
  
        this.state.selectedPost.title = event.target.value; 
        this.state.server_changes_made = false;
    }

    updateContent(event)
    {
      
        this.state.selectedPost.content = event.target.value; 
        this.state.server_changes_made = false;
    }

    updateDepartment(event)
    {
        console.log("new department ", event.target.value );
       
          this.state.selectedPost.ID = event.target.value;
          this.state.server_changes_made = false;   
    }

    onClickCancel()
    {
        this.setState({mode:0});
    }

    deletePost()
    {
      this.setState({api_loading:true, api_loading_message:"Deleting Announcement, please wait....."});
      const _this = this;


      let id = _this.state.selectedPost.id;
     
      const url = this.props.base_url +"/admin/delete_announcement";



      superagent
      .post(url)
      .send({"id":id})
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer '+ _this.state.access_token)
      .then(function(res){
          //res.body, res.headers, res.status
          let error = res.body.error;
          console.log("Response", res.body);


          if(!error)
          {

              console.log("Process", "successful posted");
              _this.setState({api_loading:false, mode:0, title:"", content:"", mode:0, loaded_successfully:true, api_error_message:"Posted successfully", department:"0", server_changes_made:true});
              _this.fetchGeneral();
      

          }
          else
          {
              _this.setState({api_loading:false, loaded_successfully:false, api_error_message:"Error creating record"});
          }

      })
      .catch(function(err){

          console.log("error response", err);
          _this.setState({api_loading:false, loaded_successfully:false, api_error_message:err});
      });

    }


  switchMode(mode, post)
  {
      this.setState({mode: mode, selectedPost:post});
  }




  fetchGeneral()
  {

        this.setState({loading:true});
        let _this = this;

            const url = this.props.base_url +"/admin/get_announcements_general";

            superagent
            .post(url)
            .send({})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("General announcements", res.body);

              _this.setState({announcements:res.body.announcements.list, server_response:res.body.message,  loading:false, loaded_successfully:true, api_error_message:"",server_changes_made:true});



            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, server_response:err, loaded_successfully:false, api_error_message:err,server_changes_made:true});
            });

  }

  editPost()
      {
        this.setState({api_loading:true, api_loading_message:"Editing Announcement, please wait....."});
        const _this = this;


        let title = _this.state.selectedPost.title;
        let content = _this.state.selectedPost.content;
        let start_date = _this.state.selectedPost.startDate ;
        let end_date = _this.state.selectedPost.endDate;
        let posted_by = _this.props.admin_details.core_details._id ;
        let general = 1;
        let department = null;
        let id =  _this.state.selectedPost.id;
        
        const url = this.props.base_url +"/admin/edit_announcement";



        superagent
        .post(url)
        .send({"title":title, "id":id, "content":content, "general":general, "department":department, "posted_by":posted_by, "start_date":start_date, "end_date": end_date})
        .set('Accept', 'application/json')
        .set('Content-Type', 'application/json')
        .set('Authorization', 'Bearer '+ _this.state.access_token)
        .then(function(res){
            //res.body, res.headers, res.status
            let error = res.body.error;
            console.log("Response", res.body);


            if(!error)
            {

                console.log("Process", "successful posted");
                _this.setState({api_loading:false, mode:0, title:"", content:"", mode:0, loaded_successfully:true, api_error_message:"Posted successfully", department:"0", server_changes_made:true});
                _this.fetchGeneral();
        

            }
            else
            {
                _this.setState({api_loading:false, loaded_successfully:false, api_error_message:"Error creating record"});
            }

        })
        .catch(function(err){

            console.log("error response", err);
            _this.setState({api_loading:false, loaded_successfully:false, api_error_message:err});
        });

      }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.authentication_error && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.api_error_message}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }


  renderEditErrorMessage()
      {
        const _this = this;
    
          if(_this.state.api_error && !_this.state.loading)
          {
              return(
                <div className="loading-progress">
                    <div className="error-message">
                        <p>{_this.state.api_error_message}</p>
                    </div>
                </div>
              );
          }
          else if(_this.server_changes_made && !_this.state.loading)
          {
              return(
                <div className="loading-progress">
                    <div className="error-message">
                        <p>{_this.state.api_error_message}</p>
                    </div>
                </div>
              );
          }
          else
          {
            return null;
          }
    
      }



  



  renderAnnouncements()
  {
    const _this = this;

    let announcement_list;

    if(_this.state.mode == 1)
    {
        let department_options;

        if(_this.props.admin_details.departments)
        {

        department_options = _this.props.admin_details.departments.map(department =>
                {
                console.log(department);
                return (
                    <option key={department.ID} value={department.ID}>{department.names}</option>
                        );
                });
        }
        else
        {
            department_options=null;
        }

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 tt">
                 <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title text-center">EDIT POST</h4>
                            </div>
                            <div className="card-body">

                                    {this.renderLoadingProgress()}
                                    {this.renderErrorMessage()}

                                

                                <div class="form-group bmd-form-group">
                                    <label for="title">Announcement Title:</label>
                                    <textarea type="text" onChange={_this.updateTitle.bind(_this)} placeholder ={_this.state.selectedPost.title}  class="form-control" rows="1" id="title"></textarea>
                                </div>


                                <div class="form-group bmd-form-group">
                                    <label for="comment">Announcement Content:</label>
                                    <textarea type="text" onChange={_this.updateContent.bind(_this)} placeholder ={_this.state.selectedPost.content}    class="form-control" rows="5" id="comment"></textarea>
                                </div>

                                

                                <div className="form-group">
                                    <label for="dt-cont">Start Date </label>
                                    <span id ="dt-cont" className="div-form-control">
                                        <DatePicker
                                                selected={_this.state.selectedPost.startDate}
                                                minDate = {_this.state.minDate}
                                                filterDate = {this.isWeekday}
                                                dateFormat="dd/MM/yyyy"
                                                yearDropdownItemNumber = {2}
                                                showYearDropdown = {true}
                                                id="dt-start"
                                                className = "bordered-form-control"
                                                scrollableYearDropdown ={true}
                                                onChange={this.updateStartDate}/> 
                                    </span>
                                </div>

                                <div className="form-group">
                                    <label for="dt-cont">End Date </label>
                                    <span id ="dt-cont" className="div-form-control">
                                        <DatePicker
                                                selected={_this.state.selectedPost.endDate}
                                                minDate = {_this.state.minDate}
                                                filterDate = {this.isWeekday}
                                                dateFormat="dd/MM/yyyy"
                                                yearDropdownItemNumber = {2}
                                                showYearDropdown = {true}
                                                id="dt-start"
                                                className = "bordered-form-control"
                                                scrollableYearDropdown ={true}
                                                onChange={this.updateEndDate}/> 
                                    </span>
                                </div>

                                {this.renderLoadingProgress()}
                                {this.renderErrorMessage()}


                                <div className="form-group bmd-form-group">
                                    <button type="submit" onClick={_this.editPost.bind(_this)} className="btn btn-rose">EDIT POST</button>  
                                </div>

                                

                              


                            

                            </div>
                        </div>  
            </div>
        );

    }
    else if(_this.state.mode == 2)
    {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 tt">
                <h3>Do you want to delete this Post?</h3>
                
                <span><span> Title : </span> <span>{_this.state.selectedPost.title} </span> </span> <br/>
                <span><span> Content : </span> <span>{ _this.state.selectedPost.title}</span> </span> <br/> 
  
                {this.renderLoadingProgress()}
                {this.renderErrorMessage()}

                 <div className="form-group bmd-form-group">
                 <button  onClick={_this.onClickCancel.bind(_this)} className="btn btn-success">CANCEL </button> 
                    <button  onClick={_this.deletePost.bind(_this)} className="btn btn-rose">DELETE POST</button>  
                 </div>  
            </div>
        );

    }
    else
    {
        if(_this.state.announcements &&  _this.state.announcements.length > 0)
        {
        

            announcement_list = _this.state.announcements.map(an =>
                {
                console.log("announcement item", an);
                return (
                    <NoticeItem key={an.id} an_details = {an}  switchMode={_this.switchMode}/>
                        );
                });
        }
        else
        {
            announcement_list = <div> <p>No announcement available.</p> </div>;
        }


  

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 tt">
            {announcement_list}
                

            </div>
        );
        }
  }

  

  componentWillMount()
  {

    
    this.fetchGeneral();
    
  }

  render() {

    const _this=this;


    if(this.state.loading)
    {
        return(
            <div >
                    Loading Announcements, Please wait......
                    <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                </div>
        );
    }

    return (
            <div className="row full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content">
                                    <div className="tab-pane active" id="profile">
                                        <h4 className ="text-center" style= {{fontWeight:"bold"}}>General Announcements</h4>


                                        {_this.renderAnnouncements()}



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>





    );
  }
}

export default General;
